import React, { useEffect, useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { PlatformService } from '../../platform/PlatformService';
import { Platform } from '../../../model/platform/Platform';
import { FaTimes } from 'react-icons/fa';
import SingleSelectDropdown, { toSelectValue } from '../../../shared/components/SingleSelectDropdown';
interface IUserPlatformLogsFilterProps {
    handleChanges: (evt: any) => void;
    handleClick: () => void;
    state: any;
    setState: any;
}
export function UserPlatformLogsFilter({ handleChanges, handleClick, state, setState }: IUserPlatformLogsFilterProps) {
    const [inputTypes, setInputTypes] = useState({
        from: 'text',
        to: 'text',
    });

    const [platforms, setPlatform] = useState<Platform[]>([]);

    useEffect(() => {
        PlatformService.getPlatforms().then(data => {
            setPlatform(data.data);
        });
    }, []);

    function handleTypes(evt: any, type: string) {
        setInputTypes(prev => ({
            ...prev,
            [evt.target.name]: type,
        }));
    }

    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="User ID"
                        className="autocomplete-input"
                        name="userId"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="@Handle"
                        className="autocomplete-input"
                        name="handle"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <SingleSelectDropdown
                        placeholder="All platforms"
                        options={platforms.map(item => ({
                            value: String(item.id),
                            label: item.name,
                            image: item.path,
                        }))}
                        withImage
                        selected={toSelectValue(state?.platformId)}
                        onChange={value => handleChanges({ target: { name: 'platformId', value } })}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <div className="d-flex bg-secondary-o-100 border rounded">
                        <Form.Control
                            placeholder="Updated from:"
                            className="autocomplete-input border-0 cursor-pointer"
                            type={inputTypes.from}
                            name="from"
                            value={state?.from || ''}
                            onFocus={e => handleTypes(e, 'date')}
                            onBlur={e => handleTypes(e, 'text')}
                            onChange={handleChanges}
                        />
                        {state?.from && (
                            <Button
                                variant=""
                                className="py-2 px-3 clearBtn btn-hover-bg-secondary"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, from: undefined }));
                                }}
                            >
                                <FaTimes fontSize={14} />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="d-flex bg-secondary-o-100 border rounded">
                        <Form.Control
                            placeholder="Updated to:"
                            className="autocomplete-input border-0 cursor-pointer"
                            type={inputTypes.to}
                            name="to"
                            value={state?.to || ''}
                            onFocus={e => handleTypes(e, 'date')}
                            onBlur={e => handleTypes(e, 'text')}
                            onChange={handleChanges}
                        />
                        {state?.to && (
                            <Button
                                variant=""
                                className="py-2 px-3 clearBtn btn-hover-bg-secondary"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, to: undefined }));
                                }}
                            >
                                <FaTimes fontSize={14} />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <SingleSelectDropdown
                        placeholder="is Manual?"
                        options={[
                            { value: 'true', label: 'Manual' },
                            { value: 'false', label: 'Not Manual' },
                        ]}
                        selected={toSelectValue(state?.manualUserInput, 'undefined')}
                        onChange={value =>
                            handleChanges({ target: { name: 'manualUserInput', value: value || 'undefined' } })
                        }
                    />
                </div>
                <div className="col-md-2 col-6">
                    <SingleSelectDropdown
                        placeholder="has Failed?"
                        options={[
                            { value: 'true', label: 'Failed' },
                            { value: 'false', label: 'Succeed' },
                        ]}
                        selected={toSelectValue(state?.hasModashFailed, 'undefined')}
                        onChange={value =>
                            handleChanges({ target: { name: 'hasModashFailed', value: value || 'undefined' } })
                        }
                    />
                </div>
            </Row>
            <Button className="mt-4" onClick={() => handleClick()}>
                Search
            </Button>
        </Form>
    );
}
